module.exports = __webpack_public_path__ + "img/kissing_closed_eyes.b6c89216.png";